import React, { useCallback, useEffect, useState } from "react";
import api from "../../utils/api/axiosInstance";
import IdentityStickyPrompt from "../wizard/IdentityStickyPrompt";
import styles from "../../styles/components/profile/ShoppingProfileSuggestionBanner.module.css";

/**
 * Auto-suggested shopping profile updates (budget, etc.) from activity signals.
 */
const ShoppingProfileSuggestionBanner = ({
  onAccepted,
  className = "",
  variant = "default",
}) => {
  const [suggestion, setSuggestion] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/users/me/shopping-identity/suggestions");
      setSuggestion(res.data?.suggestion || null);
    } catch {
      setSuggestion(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleDismiss = async () => {
    if (!suggestion?.id) return;
    try {
      await api.post("/users/me/shopping-identity/suggestions/dismiss", {
        key: suggestion.id,
      });
    } catch {
      /* still hide locally */
    }
    setSuggestion(null);
  };

  const handleAccepted = (data) => {
    setSuggestion(null);
    onAccepted?.(data);
  };

  if (loading || !suggestion?.fields) return null;

  return (
    <div className={`${styles.wrap} ${className}`.trim()}>
      <p className={styles.kicker}>Suggested profile update</p>
      <IdentityStickyPrompt
        proposal={suggestion}
        variant={variant}
        acceptLabel="Update profile"
        onAccepted={handleAccepted}
        onDismiss={handleDismiss}
      />
    </div>
  );
};

export default ShoppingProfileSuggestionBanner;
